"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapitalizedWordEntryLearnText = exports.getCapitalizedSpecialWordLearnText = exports.getCapitalizedSentenceWordText = void 0;
const lodash_1 = require("lodash");
const gender_utils_1 = require("./gender_utils");
const getCapitalizedSentenceWordText = ({ langPairCode, sentenceWord, }) => {
    var _a;
    if (langPairCode !== "en-US_de-DE") {
        return sentenceWord;
    }
    const isWordCapitalized = (_a = sentenceWord.tags) === null || _a === void 0 ? void 0 : _a.some((tag) => gender_utils_1.isGenderString(tag));
    if (!isWordCapitalized) {
        return sentenceWord;
    }
    return {
        learn_txt: lodash_1.capitalize(sentenceWord.learn_txt),
        root_txt: lodash_1.capitalize(sentenceWord.root_txt),
    };
};
exports.getCapitalizedSentenceWordText = getCapitalizedSentenceWordText;
const getCapitalizedSpecialWordLearnText = ({ langPairCode, specialWord, }) => langPairCode === "en-US_de-DE" &&
    specialWord.word_learn_gender &&
    gender_utils_1.isGenderString(specialWord.word_learn_gender)
    ? lodash_1.capitalize(specialWord.learn_txt)
    : specialWord.learn_txt;
exports.getCapitalizedSpecialWordLearnText = getCapitalizedSpecialWordLearnText;
const getCapitalizedWordEntryLearnText = ({ langPairCode, specialWord, wordEntryLearnText, }) => exports.getCapitalizedSpecialWordLearnText({
    langPairCode,
    specialWord: { ...specialWord, learn_txt: wordEntryLearnText },
});
exports.getCapitalizedWordEntryLearnText = getCapitalizedWordEntryLearnText;
//# sourceMappingURL=capitalization_utils.js.map